// Angular
import { Component, ComponentFactoryResolver, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
// Modules
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ModalService, ModalSize } from '@cv-invision/core';
// Service
import { SoftwareCollectorPackagesService } from '../../service/software-collector-packages.service';
// Other
import { CreateUpdatePackageComponent } from '../create-update-package/create-update-package.component';

@Component({
	selector: 'cv-software-collector-package-custom-action',
	templateUrl: './custom-action-software-collector-package-cell.component.html',
	styleUrls: ['./custom-action-software-collector-package-cell.component.scss']
})
export class CustomActionSoftwareCollectorPackageCellComponent implements ICellRendererAngularComp, OnDestroy {
	private atComponentDestroy: Subject<any> = new Subject<any>();
	public cellValue: any;

	constructor(
		private componentFactoryResolver: ComponentFactoryResolver,
		private modalService: ModalService,
		private softwareCollectorService: SoftwareCollectorPackagesService
	) {}

	/**
	 * When the component renders, it got the possible value
	 * @param params
	 */
	agInit(params: ICellRendererParams): void {
		this.cellValue = params.data;
	}

	/**
	 * edit Products
	 */
	onEditProducts(): void {
		this.modalService
			.open({
				componentFactoryResolver: this.componentFactoryResolver,
				component: CreateUpdatePackageComponent,
				data: {
					isEditing: true,
					insideMapsId: this.cellValue.id
				},
				modalConfiguration: {
					title: 'Edit Package Configuration',
					modalSize: ModalSize.XL
				}
			})
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(result => {
				if (result.success) {
					this.softwareCollectorService.setReloadListConfirmation({
						reloadList: true
					});
				} else {
					// it failed :(
				}
			});
	}

	/**
	 * Put back the value
	 * @param params
	 */
	refresh(params: ICellRendererParams): boolean {
		this.cellValue = params;
		return true;
	}

	ngOnDestroy(): void {
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}
}
